import * as React from 'react';
import { Link } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
const styles = StyleSheet.create({
    container: {
        fontSize: 12,
        [MediaBreakPointUp.SM]: {
            fontSize: 14,
        },
        color: Colors.PrimaryDark,
        textDecoration: 'none',
        letterSpacing: '0.02em',
        cursor: 'pointer',
        fontWeight: 600,
    },
});
export const MoreLink = ({ to, onClick }) => to ? (React.createElement(Link, { to: to, className: css(styles.container) }, "\u3059\u3079\u3066\u898B\u308B")) : (React.createElement("div", { onClick: onClick, className: css(styles.container) }, "\u3059\u3079\u3066\u898B\u308B"));
